/* src/app/shared-module/components/sub-header-toolbar/sub-header-toolbar.component.scss */
.back-icon {
  font-size: 20px;
  margin-top: 0px;
  margin-left: 10px;
  float: left;
  color: var(--ion-color-primary-contrast);
  cursor: pointer;
}
.search-card-content {
  width: 100%;
  display: flex;
}
.circle-div-search {
  height: 35px;
  width: 35px;
  background-color: var(--ion-color-primary-tint);
  border-radius: 50%;
  display: table-cell;
  vertical-align: middle;
  text-align: center;
  text-decoration: none;
  float: right;
}
.search-icon {
  font-size: 20px;
  padding-top: 8px;
  padding-left: 1px;
}
.heart-icon {
  font-size: 20px;
  padding-top: 8px;
  padding-left: 1px;
  color: var(--ion-color-primary);
}
.heart-col {
  padding-top: 8px;
}
ion-button {
  padding-inline-start: 0px !important;
  padding-inline-end: 0px !important;
  padding: 8px;
}
.search-text {
  position: absolute;
  margin: 6px 2px 2px 8px;
}
.close-dialog {
  font-size: 25px;
  float: inline-end;
}
ion-card {
  margin-inline-end: 0px !important;
  margin-inline-start: 0px !important;
  margin-block-start: 0px !important;
  margin-block-end: 0px !important;
  border-radius: 64px !important;
  padding: 3px;
  box-shadow: none !important;
}
.example-button-row {
  display: table-cell;
  font-family: Roboto-Bold, sans-serif !important;
}
.example-button-row .mat-mdc-button-base {
  margin: 8px 8px 8px 0;
}
.profile-icon {
  font-size: 45px;
  margin-top: 0px;
  float: left;
  color: var(--ion-color-primary-contrast);
}
.title {
  color: var(--ion-color-primary-contrast);
  margin-left: 5px;
  cursor: pointer;
}
.header-ion-row {
  padding: 0px 0px 4px 0px;
}
.header-ion-row-home {
  padding: 0px 0px 4px 0px;
}
.home-toolbar-row {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 4px 2px;
  gap: 8px;
}
.toolbar-avatar,
.toolbar-action-btn {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.15);
  border: 1.5px solid rgba(255, 255, 255, 0.35);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex-shrink: 0;
  padding: 0;
  -webkit-backdrop-filter: blur(4px);
  backdrop-filter: blur(4px);
  transition: background 0.2s ease;
}
.toolbar-avatar:active,
.toolbar-action-btn:active {
  background: rgba(255, 255, 255, 0.28);
}
.toolbar-avatar ion-icon,
.toolbar-action-btn ion-icon {
  font-size: 20px;
  color: var(--ion-color-primary-contrast);
}
.toolbar-action-btn .toolbar-heart-icon {
  font-size: 18px;
  color: var(--ion-color-primary-contrast);
}
.toolbar-center {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
}
.toolbar-location-chip {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  max-width: 100%;
  padding: 5px 12px 5px 6px;
  border: none;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.12);
  border: 1px solid rgba(255, 255, 255, 0.28);
  -webkit-backdrop-filter: blur(6px);
  backdrop-filter: blur(6px);
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  transition:
    background 0.2s ease,
    border-color 0.2s ease,
    transform 0.15s ease;
}
.toolbar-location-chip:hover {
  background: rgba(255, 255, 255, 0.18);
  border-color: rgba(255, 255, 255, 0.42);
}
.toolbar-location-chip:active {
  transform: scale(0.97);
  background: rgba(255, 255, 255, 0.24);
}
.toolbar-location-chip-cta {
  border: 1.5px dashed rgba(255, 255, 255, 0.5);
}
.toolbar-location-icon-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.18);
  flex-shrink: 0;
}
.toolbar-location-icon-wrap ion-icon {
  font-size: 14px;
  color: var(--ion-color-primary-contrast);
}
.toolbar-location-copy {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  line-height: 1.15;
  min-width: 0;
}
.toolbar-location-kicker {
  font-size: 9.5px;
  font-weight: 600;
  letter-spacing: 0.07em;
  color: var(--ion-color-primary-contrast);
}
.toolbar-location-text {
  font-size: 14px;
  font-weight: 700;
  color: var(--ion-color-primary-contrast);
  letter-spacing: 0.01em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 160px;
}
.toolbar-location-chevron {
  font-size: 13px;
  color: var(--ion-color-primary-contrast);
  flex-shrink: 0;
}
.toolbar-app-title {
  font-size: 13px;
  font-weight: 700;
  color: var(--ion-color-primary-contrast);
  letter-spacing: 0.02em;
  white-space: nowrap;
}
.toolbar-action-placeholder {
  width: 40px;
  height: 40px;
  flex-shrink: 0;
}
.addpro-btn {
  border: 1.5px solid;
  padding: 5px;
  --background: transparent !important;
  --box-shadow: none !important;
  float: inline-end;
  border-radius: 10px;
}
/*# sourceMappingURL=sub-header-toolbar.component.css.map */
